module.exports = __webpack_public_path__ + "img/Newbie_Sword_01_Warrior.1ad53cef.png";